// PDF 상품 정보 (무료 PDF 제공용)
//
// 이 배열이 PDF 상품의 단일 출처(SSOT)다. 서버 grant allowlist
// (`src/lib/server-utils/grant-free-pdf.ts`)와 사은품 지급 스크립트
// (`.claude/skills/gift-reply-alimtalk/scripts/grant_pdf.py`)가 모두 이 목록을 본다.
// 스크립트는 실행 시점에 이 파일을 직접 파싱하므로 시즌 전환 시 여기만 갱신하면 된다 (JCG-3582).
//
// 스크립트가 의존하는 ID 관례(`tests/constants/pdfProducts.test.ts`가 강제):
// - ID는 `<YY>-<회차>-<종류>` 형식이고, 가장 큰 `<YY>-<회차>`가 현재 시즌이다.
// - 스크립트의 `이론`/`코딩` 별칭은 현재 시즌의 `-compressed-pdf`/`-coding-pdf`로 해석된다.
//   회차 전환기처럼 한쪽이 아직 없으면 그 별칭은 만들어지지 않고 호출 시 에러가 난다.
export const PDF_PRODUCTS = [
  { id: "26-3-compressed-pdf", name: "2026년 3회 실기 이론 요약 PDF (압축)" },
  { id: "26-3-coding-pdf", name: "2026년 3회 실기 코딩 요약 PDF" },
  { id: "26-1-compressed-pdf", name: "2026년 1·2회 통합 실기 이론 요약 PDF (압축)" },
  { id: "26-1-coding-pdf", name: "2026년 1·2회 통합 실기 코딩 요약 PDF" },
  { id: "25-3-super-compressed-pdf", name: "2025년 3회 실기 이론 요약 PDF (초압축)" },
  { id: "25-3-compressed-pdf", name: "2025년 3회 실기 이론 요약 PDF (압축)" },
  { id: "25-2-super-compressed-pdf", name: "2025년 2회 실기 이론 요약 PDF (초압축)" },
] as const;

export type PdfProductId = (typeof PDF_PRODUCTS)[number]["id"];

// 상품 ID로 상품명 조회
export const getProductName = (productId: string): string => {
  const product = PDF_PRODUCTS.find((p) => p.id === productId);
  return product?.name || productId;
};
